import AccordionNav from './AccordionNav';

const NAV_OPEN = 'state--mobile-nav-open';

class MobileNav {
    $containerEl = $('body');
    $openBtn = $('#actionOpenMobileNav');
    $closeBtn = $('#actionCloseMobileNav');
    $navContainer = $('#mobileNav');
    $primaryNav = $('#mobileNavPrimary');

    constructor() {
        this.attachEvents();

        new AccordionNav(this.$primaryNav);
    }

    attachEvents() {
        this.$openBtn.on('click', this.openNav.bind(this));
        this.$closeBtn.on('click', this.closeNav.bind(this));

        this.$navContainer.find('#mobileNavToStart').on('focus', () => {
            this.$navContainer.find('a').first().focus();
        });

        this.$navContainer.find('#mobileNavToEnd').on('focus', () => {
            this.$navContainer.find('a').last().focus();
        });
    }

    openNav() {
        // Open the nav
        this.$containerEl.addClass(NAV_OPEN);

        // Apply focus to the first nav item
        setTimeout(() => {
            this.$primaryNav.find('a').first().focus();
        });
    }

    closeNav() {
        this.$containerEl.removeClass(NAV_OPEN);
        this.$openBtn.focus();
    }
}

export default MobileNav;
